/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { V as Variants } from './constants-c94b83bd.js';
import { D as DHL_HEADLINE } from './constants-366d7065.js';

const DHL_GLOBAL_VALIDATION_VARIANT = {
    VALID: Variants.valid,
    INVALID: Variants.invalid,
};
const DHL_GLOBAL_VALIDATION = {
    VARIANT: DHL_GLOBAL_VALIDATION_VARIANT,
    HEADLINE_TAG: DHL_HEADLINE.TAG,
};

export { DHL_GLOBAL_VALIDATION as D };

//# sourceMappingURL=constants-ac0e2540.js.map